export default __webpack_public_path__ + "static/media/nass.5baa5592.jpeg";